const React = require('react')
const { useEffect, useState } = require('react')
const { Container, Row, Col } = require('reactstrap')
const { useParams, useHistory } = require('react-router-dom')
const { useBlockchainData } = require('@hooks')
const { useNetworkConfig } = require('@contexts')
const { Tabs } = require('@components')

const { BlockDetails } = require('./details.block')
const { BlockConsensus } = require('./consensus.block')
const { BlockMev } = require('./mev.block')
const { BlockBlob } = require('./blob.block')

require('@styles/pages/block/index.css')

const Block = () => {
    const { blockNumber } = useParams()
    const history = useHistory()
    const { network } = useNetworkConfig()
    const { getBlock, getBlocks } = useBlockchainData(network.name)

    const isBlockchain_1 = network.data.type === 'Ethereum 1.0'
    const isBlockchain_2 = network.data.type === 'Ethereum 2.0'

    const [loading, setLoading] = useState(false)
    const [blockData, setBlockData] = useState(null)
    const [latestBlock, setLatestBlock] = useState(0)
    const [blockTime, setBlockTime] = useState(0)

    const [activeTab, setActiveTab] = useState(() => {
        const urlHash = window.location.hash.slice(1)
        return urlHash || 'overview'
    })
    const [isDetailsExpanded, setIsDetailsExpanded] = useState(false)

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true)
                setIsDetailsExpanded(false)

                const [prevBlockResponse, blockResponse, blocksResponse] = await Promise.all([
                    getBlock(blockNumber - 1),
                    getBlock(blockNumber),
                    getBlocks(1, 1)
                ])

                if (blockResponse && blocksResponse) {
                    if (blockNumber > blocksResponse.totalItems - 1) {
                        history.push(`/${network.name}/block/countdown/${blockNumber}`)
                        return
                    }

                    setBlockData(blockResponse)
                    setLatestBlock(blocksResponse.totalItems - 1)

                    if (prevBlockResponse) {
                        setBlockTime(blockResponse.timestamp - prevBlockResponse.timestamp)
                    }
                }
                setLoading(false)
            } catch (error) {
                console.error('Error fetching data:', error)
                setLoading(false)
            }
        }
        fetchData()
    }, [blockNumber])

    return (
        <div className='page'>
            <Container>
                <Col>
                    <Row>
                        <div className='page-header'>
                            <text className='page-title'>
                                Block
                                <span className='page-title-subcontent'>{` #${blockNumber}`}</span>
                            </text>
                            <div className='page-title-border' />
                        </div>
                    </Row>
                    <Tabs
                        activeTab={activeTab}
                        items={
                            isBlockchain_1
                                ? [{ tab: 'overview', text: 'Overview' }]
                                : [
                                      { tab: 'overview', text: 'Overview' },
                                      {
                                          tab: 'consensusinfo',
                                          text: 'Consensus Info'
                                      },
                                      { tab: 'mevinfo', text: 'MEV Info' },
                                      { tab: 'blobinfo', text: 'Blob Info' }
                                  ]
                        }
                        onTabChange={setActiveTab}
                    />
                    {activeTab === 'overview' && (
                        <BlockDetails
                            loading={loading}
                            data={blockData}
                            latestBlock={latestBlock}
                            blockTime={blockTime}
                            isDetailsExpanded={isDetailsExpanded}
                            setIsDetailsExpanded={setIsDetailsExpanded}
                        />
                    )}
                    {activeTab === 'consensusinfo' && !isBlockchain_1 && (
                        <BlockConsensus loading={loading} data={blockData} />
                    )}
                    {activeTab === 'mevinfo' && !isBlockchain_1 && <BlockMev loading={loading} data={blockData} />}
                    {activeTab === 'blobinfo' && !isBlockchain_1 && <BlockBlob loading={loading} data={blockData} />}
                </Col>
            </Container>
        </div>
    )
}

module.exports = Block
